import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { combineLatest, Subscription } from 'rxjs';
import { Hiring } from 'src/app/classes/hiring';
import { PlanningHasEntity } from 'src/app/classes/planning-has-entity.class';
import { Planning } from 'src/app/classes/planning.class';
import { PlanningAsfaltteam } from 'src/app/classes/planningasfaltteam.class';
import { PlanningCutter } from 'src/app/classes/planningcutter.class';
import { PlanningDumper } from 'src/app/classes/planningdumper.class';
import { PlanningSet } from 'src/app/classes/planningset.class';
import { User } from 'src/app/classes/user.class';
import { EntitiesService } from 'src/app/services/entities/entities.service';
import { PlanningService } from 'src/app/services/planning/planning.service';
import { UserService } from 'src/app/services/user/user.service';
import { Utils } from 'src/app/utils.class';
import { CodaltComponent } from '../../codalt.component';

@Component({
    selector: 'app-hired-companies-dialog',
    templateUrl: './hired-companies-dialog.component.html',
    styleUrls: ['./hired-companies-dialog.component.scss'],
    standalone: false,
})
export class HiredCompaniesDialogComponent extends CodaltComponent implements OnInit {
    selectedWeek: WeekOption;

    weeks: WeekOption[] = [];
    today = new Date();

    hirePerCompany: {
        company: Hiring;
        hiring: {
            planning: Planning;
            performer: User;
            hired: PlanningCutter | PlanningHasEntity | PlanningAsfaltteam | PlanningSet | PlanningDumper;
        }[];
    }[];

    constructor(
        public dialogRef: MatDialogRef<HiredCompaniesDialogComponent>,
        private entitiesService: EntitiesService,
        private usersService: UserService,
        private planningService: PlanningService
    ) {
        super();
    }

    ngOnInit(): void {
        const monday = new Date();

        // Calculate the monday
        monday.setDate(monday.getDate() - ((monday.getDay() % 7) - 1));
        Utils.setTime(monday, 0, 0);
        const sunday = new Date(monday);
        sunday.setDate(monday.getDate() + 6);
        Utils.setTime(sunday, 23, 59, 59);
        this.weeks.push({
            startDate: new Date(monday),
            endDate: new Date(sunday),
        });
        for (let i = 1; i < 15; i++) {
            monday.setDate(monday.getDate() + 7);
            sunday.setDate(sunday.getDate() + 7);
            this.weeks.push({
                startDate: new Date(monday),
                endDate: new Date(sunday),
            });
        }
    }

    showHire(week: WeekOption) {
        this.selectedWeek = week;
        const entities$ = this.entitiesService.getMap();
        const planning$ = this.planningService.getFilteredList(week.startDate, week.endDate);
        const users$ = this.usersService.getMap();
        const subs = new Subscription();
        subs.add(
            combineLatest(entities$, planning$, users$).subscribe(([entitiesMap, planningList, usersMap]) => {
                const hirePerCompany = new Map<
                    number,
                    {
                        planning: Planning;
                        hired: PlanningCutter | PlanningHasEntity | PlanningAsfaltteam | PlanningSet | PlanningDumper;
                        performer: User;
                    }[]
                >();
                planningList
                    .sort(
                        (a, b) =>
                            new Date(Utils.mainPlanning(a).begindate).getTime() -
                            new Date(Utils.mainPlanning(b).begindate).getTime()
                    )
                    .forEach(planning => {
                        const hired = planning.planning_has
                            .filter(p => !!p.hiring_id && !entitiesMap.get(p.entity_id).use_once)
                            .filter(
                                a =>
                                    Utils.getTimeOrNull(a.begindate) >= week.startDate.getTime() &&
                                    Utils.getTimeOrNull(a.begindate) <= week.endDate.getTime()
                            );
                        hired.forEach(hire => {
                            hire.entity = entitiesMap.get(hire.entity_id);
                            hire.lowloader_entity = entitiesMap.get(hire.lowloader_entity_id);
                            let items = hirePerCompany.get(hire.hiring_id) || [];
                            items.push({
                                hired: hire,
                                planning: planning,
                                performer: usersMap.get(planning.performer),
                            });
                            hirePerCompany.set(hire.hiring_id, items);
                        });
                    });
                this.hirePerCompany = [];
                hirePerCompany.forEach((value, key) => {
                    this.hirePerCompany.push({
                        company: value[0].hired.hiring,
                        hiring: value.sort(
                            (a, b) => new Date(a.hired?.begindate).getTime() - new Date(b.hired?.begindate).getTime()
                        ),
                    });
                });
            })
        );
    }

    close() {
        this.dialogRef.close();
    }

    copyToClipboard(string) {
        Utils.copyToClipboard(string);
    }
}

interface WeekOption {
    startDate: Date;
    endDate: Date;
}
